export default __webpack_public_path__ + "static/banner_app_light-ac96dd14165286c79d5a4ac8430959ad.png";